<template>
	<button :type="(type)?type:'button'" @click="$emit('click', $event)" :disabled="disabled">
		<slot></slot>
		<icon v-if="icon" :icon="icon"></icon>
	</button>
</template>

<script>
	export default {
		props: ['icon', 'type', 'disabled']
	}
</script>